import { isDefined } from "@clipboard-health/util-ts";

export function getPageCursor(cursorUrl: string): string | undefined {
  const search = cursorUrl.split("?")[1];
  if (!isDefined(search)) {
    return undefined;
  }

  const searchParams = new URLSearchParams(search);

  return searchParams.get("page[cursor]") ?? undefined;
}
